import { render, staticRenderFns } from "./StudyProgramForm.vue?vue&type=template&id=65ff5e20&scoped=true&"
import script from "./StudyProgramForm.vue?vue&type=script&lang=ts&"
export * from "./StudyProgramForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudyProgramForm.vue?vue&type=style&index=0&id=65ff5e20&lang=scss&scoped=true&"
import style1 from "./StudyProgramForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff5e20",
  null
  
)

export default component.exports